/**
 * Created by 唐亦慧 on 2018/2/6.
 * zhouyanping 2021年4月15日21:00:38 update
 * 修改商品选型
 */
import React from 'react';
import Reflux from 'reflux';
import {
  hashHistory,
  withRouter,
} from 'react-router';
import {
  Row,
  Col,
  Layout,
  Form,
  Input,
  Radio,
  Cascader,
  Pagination,
  message,
  Spin,
  Avatar,
  Select,
  Button,
} from 'antd';
import '../mall-menus.css';
import '../mallApp.css';

import {
  isShowInventory,
} from '../../service/mall';
import {
  commodityModelSelectionList,
} from '../../service/merchandise';
import {
  getProductCategory,
} from '../../service/product';
import {
  sKeylist,
} from '../../service/dictionary/dataitem';
import {
  returnFloat,
  config,
} from 'Utils';
import {
  productActions,
  productStore,
} from './store';

const FormItem = Form.Item;
const Search = Input.Search;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

class MallHome extends Reflux.Component {
  constructor(props) {
    super(props);
    this.store = Reflux.initStore(productStore);
    this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
    this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
    this.state = {
      isShow: true, //是否显示库存
      tree: [],
      seriesOptions: [],
      seriesStyle:{background:'#ffffff',height:'280px'}, // 商品系列样式
      searchObj: {
        name: '',
        proBigType: '',
        proMiddleType: '',
        proDetailType: '',
        seriesCode: '',
        isHot: '1',
        isNew: '1',
        p: 1,
        s: 10,
      },
      list: [],
      total: 0,
      loading: false,
    };
    this.getCategoryTree = this.getCategoryTree.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.goView = this.goView.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
    this.getData = this.getData.bind(this);
    this.isShowInventory = this.isShowInventory.bind(this);
  }

  //离开当前路由时，更新store
  routeLeaveHook(nextLocation) {
    const { searchObj } = this.state;
    let path = nextLocation.pathname.split('/');
    if (path[1] === 'mallCommon' && path[2] === 'productDetail') { //当下一个路由是详情页时，将useStore的值设为true
      productActions.useStoreChange(true);
      productActions.paramChange(searchObj);
    } else {
      productActions.useStoreChange(false);
      productActions.paramChange({});
    }
  }

  componentWillMount() {
    const data = this.store.state;
    if (data.useStore) { //根据useStore的值判断是否使用store中的数据
      this.setState({
        searchObj: data.storeData,
      });
    }
  }

  componentDidMount() {
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    this.getCategoryTree();
    this.isShowInventory();
    let inIframe = /^\/mallSelect/.test(this.props.location.pathname);
    // 订单商品选型默认不查询商品。
    if(!inIframe){
      this.getData();
    }else{
      // iframe设置滚动条
      let iframe = document.getElementById('root');
      iframe.setAttribute('class','mall-scrollbar');
      iframe.setAttribute('name','my-scrollbar');
      iframe.style.border = '1px solid #dcdcdc';
      iframe.style.overflowX = 'hidden';
    }
    sKeylist({ sKey: 'commodity_series' }).then(res => {
      if (res.status) {
        let list =  (res.data || []).map(x => ({
          value: x.sKey,
          text: x.name,
          url: x.filePath ? `${config.server}/${x.filePath}` : '',
        }))

        this.setState({
          seriesOptions:list,
          // seriesStyle:{...this.state.seriesStyle, minWidth:(list.length * 179)+'px'}
        });
      }
    });
  }

  isShowInventory() {
    isShowInventory().then((result) => {
      if (result && result.status) {//{show_inventory: "N", allow_reservation: "Y"}
        var isShowInventory = result.data;
        if (isShowInventory.show_inventory && isShowInventory.show_inventory == 'N') {
          this.setState({
            isShow: false,
          });
        } else {
          this.setState({
            isShow: true,
          });
        }
        if (isShowInventory.allow_reservation && isShowInventory.allow_reservation == 'N') {
          this.setState({
            zeroAdd: false,
          });
        } else {
          this.setState({
            zeroAdd: true,
          });
        }
      } else {
        message.error(result.message);
      }
    });
  }

  //获取菜单
  getCategoryTree() {
    getProductCategory().then((res) => {
      if (res.status) {
        const filterEmpty = (list, codePath) => list.map(x => {
          let key = x.code; // 实际使用的业务数据是 code；
          if (x.children && x.children.length) {
            return {
              ...x,
              key: key, // 使用实际业务数据重新给 key 赋值
              value: key, // 使用实际业务数据重新给 value 赋值
              isLeaf: false,
              disableCheckbox: !x.categoryId,
              codePath: [...codePath, x.code],
              children: filterEmpty(x.children, [...codePath, x.code]),
            };
          }
          return {
            ...x,
            key: key, // 使用实际业务数据重新给 key 赋值
            value: key, // 使用实际业务数据重新给 value 赋值
            isLeaf: true,
            disableCheckbox: !x.categoryId,
            codePath: [...codePath, x.code],
            children: undefined,
          };
        });
        const tree = filterEmpty(res.data || [], []);
        this.setState({
          tree: tree,
        });
      } else {
        message.error(res.message);
      }
    });
  }

  //获取数据
  getData() {
    const { searchObj } = this.state;
    this.setState({ loading: true });
    commodityModelSelectionList(searchObj).then((result) => {
      this.setState({ loading: false });
      if (result.status) {
        this.setState({
          list: (result.data || []).map(x => ({
            ...x,
            picPreviewUrl: `${config.server}${x.picPreviewUrl}`,
          })),
          total: result.total || 0,
        });
      } else {
        message.error(result.message);
      }
    });
  }

  pageChange(page, pageSize) {
    this.setState({
      searchObj: {
        ...this.state.searchObj,
        p: page,
      },
    }, () => {
      this.getData();
    });
  }

  //页面跳转
  goView(url) {
    hashHistory.push(url);
  }

  CascaderFilter = (inputValue, path) => {
    return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
  };

  // 搜索
  searchObjChange = (key, value) => {
    if (key === 'category') {
      const [proBigType, proMiddleType, proDetailType] = value;
      this.setState({
        searchObj: {
          ...this.state.searchObj,
          proBigType,
          proMiddleType,
          proDetailType,
          p: 1,
        },
      }, () => {
        this.getData();
      });
    } else {
      this.setState({
        searchObj: {
          ...this.state.searchObj,
          [key]: value,
          p: 1,
        },
      }, () => {
        this.getData();
      });
    }
  };

  resetForm = () => {
    this.props.form.resetFields();
    this.setState({
      searchObj: {
        ...this.state.searchObj,
        proBigType: '',
        proMiddleType: '',
        proDetailType: '',
        name: '',
        stockType: '',
        p: 1
      }
    }, () => {
      this.getData();
    })
  }


  searchHandle(){
    const { searchObj } = this.state;
    const { getFieldsValue} = this.props.form
    const values = getFieldsValue();
    const [proBigType, proMiddleType, proDetailType] = values.category;
    this.setState({
      searchObj: {
        ...searchObj,
        proBigType,
        proMiddleType,
        proDetailType,
        name: values.name,
        stockType: values.stockType,
        p: 1
      }
    }, () => {
      this.getData();
    })
  }

  render() {
    const {
      zeroAdd, isShow, loading, lables, searchObj, total, list,
      tree, seriesOptions,seriesStyle
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout1 = {
      labelCol: { span: 0 },
      wrapperCol: { span: 24 },
    };
    const formItemLayout = {
      labelCol: { span: 3 },
      wrapperCol: { span: 21 },
    };
    return <div style={{overflowX: 'hidden'}}>
      <Layout style={{ background: '#fff' }}>
        <Form layout="horizontal">
          <Row gutter={16}>
            <Col span={6}>
              <FormItem {...formItemLayout1} label={null} colon={false}>
                {getFieldDecorator('name')(
                  <Search
                    placeholder="请输入关键字搜索"
                    onSearch={val => this.searchObjChange('name', val)}
                    style={{ width: '100%' }} />,
                )}
              </FormItem>
            </Col>
            <Col span={14}>
              <FormItem {...formItemLayout} label="产品分类">
                {getFieldDecorator('category', {
                  getValueFromEvent: (e) => {
                    this.searchObjChange('category', e);
                    return e;
                  },
                })(
                  <Cascader
                    options={tree}
                    placeholder="请选择产品分类"
                    showSearch={{ filter: this.CascaderFilter }}
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={4} style={{display: 'flex', justifyContent: 'flex-end'}}>
              <Button onClick={() => this.resetForm()}>重置</Button>
              &emsp;&emsp;
              <Button type="primary" onClick={this.searchHandle.bind(this)}>搜索</Button>
            </Col>
          </Row>
          <FormItem className="dms-radio-img-box" label={null} colon={false}>
            {getFieldDecorator('seriesCode', {
              // getValueFromEvent: (e) => {
              //   this.searchObjChange('seriesCode', e.target.value);
              //   return e.target.value;
              // },
            })(
              <div className="mall-scrollbar">
                <RadioGroup style={seriesStyle} onChange={(event)=>{this.searchObjChange('seriesCode', event.target.value)}}>
                  {
                    seriesOptions.map(x => (
                      <RadioButton key={x.value} className="dms-radio-img" value={x.value}>
                        <Avatar className="ant-avatar-max" src={x.url} />
                        <p>{x.text}</p>
                      </RadioButton>
                    ))
                  }
                </RadioGroup>
              </div>,
            )}
          </FormItem>
        </Form>
        <Spin spinning={loading}>
          {
            list.length > 0 &&
            <div className='goods-list clear'>
              {
                list.map((item, key) => {
                  return <dl key={key}>
                    <dt onClick={this.goView.bind(this, `/mallSelect/productDetail/${item.id}/${item.productId}/select`)}>
                      <img src={item.picPreviewUrl ? item.picPreviewUrl : require('../../assets/images/product-default.png')}
                           onError={e => {e.target.src = require('../../assets/images/product-default.png');}}
                           alt="图片加载失败" />
                      {
                        item.minPrice > item.minPromotionPrice && item.promotionCount > 0 &&
                        <div></div>
                      }
                      {
                        item.minPrice > item.minPromotionPrice && item.promotionCount > 0 &&
                        <p>促销</p>
                      }
                      {
                        item.inventory == 0 && !zeroAdd &&
                        <i className="dmsIcon dmsSoldOut"></i>
                      }
                    </dt>
                    <dd>
                      <div
                        onClick={this.goView.bind(this, `/mallSelect/productDetail/${item.id}/${item.productId}/select`)}>
                        {
                          !!item.labeling &&
                          <span style={{
                            display: 'inline-block',
                            fontSize: '12px',
                            height: '17px',
                            lineHeight: '14px',
                            padding: '0 3px',
                            border: '1px solid #d61518',
                            color: '#d61518',
                            borderRadius: '3px',
                            marginRight: '5px',
                          }}>{lables[item.labeling]}</span>
                        }
                        {item.name}
                      </div>
                      <p>
                        {/* <span>{returnFloat(item.showPrice)}</span>
                        {
                          isShow &&
                          <span style={{
                            float: 'right',
                            fontSize: '12px',
                          }}>总销量 {item.totalSalesNum}</span>
                        } */}
                        {
                          (!isShow && !zeroAdd) && item.inventory > 0 &&
                          <span style={{ float: 'right', fontSize: '12px' }}>有货</span>
                        }
                        {
                          (!isShow && !zeroAdd) && !(item.inventory > 0) &&
                          <span style={{ float: 'right', fontSize: '12px' }}>缺货</span>
                        }
                      </p>
                    </dd>
                  </dl>;
                })
              }
            </div>
          }
          {
            list.length > 0 &&
            <div className="mall-page">
              <Pagination
                showQuickJumper
                showTotal={total => `共 ${total} 条`}
                defaultCurrent={1}
                current={searchObj.p}
                total={total}
                onChange={this.pageChange}
                defaultPageSize={searchObj.s}
              />
            </div>
          }
          {
            list.length == 0 &&
            <div style={{
              width: '100%',
              minHeight: this.state.mainHeight,
              textAlign: 'center',
              position: 'relative',
            }}>
              <img style={{
                width: '200px',
                height: '200px',
                position: 'absolute',
                top: '28px',
                left: '50%',
                marginLeft: '-100px',
              }} src={require('../../assets/images/null.png')} alt="" />
              <p style={{
                width: '100%',
                height: '274px',
                paddingTop: '250px',
                textAlign: 'center',
                lineHeight: '24px',
                fontSize: '18px',
                color: '#999',
              }}>暂无数据</p>
            </div>
          }
        </Spin>
      </Layout>
    </div>;
  }
}
;
export default Form.create()(withRouter(MallHome));



// WEBPACK FOOTER //
// ./src/mall/mallHome/selectHome.js